import BaseForm from "./baseForm";

export default class LogosForm extends BaseForm {

	constructor() {
		super('logos-form');
	}

	init() {
        super.init("logos-form");
    }

	getFormValidationConstraints() {
        return {
            ...this.notEmptyConstraint("name"),
            ...this.notEmptyConstraint("lastname"),
            ...this.notEmptyConstraint("organisation"),
            ...this.emailConstraint("email")
        };
    }

} 